module.exports = __webpack_public_path__ + "static/img/reference pics_Brazil pool.d175c1cc.jpg";